import { styled } from '@mui/material';

export const StyledLessonLinkList = styled('div')({
	display: 'flex',
	padding: '0',
	margin: '0',
	flexDirection: 'column',
	gap: '8px',
});

export const StyledLessonLinkItemTitleWrap = styled('div')({
	display: 'flex',
	alignItems: 'center',
	gap: '4px',
});

export const StyledLessonLinkItemTitleImage = styled('img')({
	width: '16px',
	maxWidth: '16px',
	height: '16px',
	borderRadius: '4px',
	marginBottom: '2px',
});
